import Vue from 'vue'
import VueSocketIOExt from 'vue-socket.io-extended';
import { io } from 'socket.io-client';

const socket = io('https://cable.fitclass.com');

Vue.use(VueSocketIOExt, socket);